export default function YellowCursor() {
    return (
        <svg width="100%" height="100%" viewBox="0 0 46 52" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.34766 3.34326L12.9302 48.6564L21.9947 29.418L43.1303 27.0591L3.34766 3.34326Z" fill="#FFC525" stroke="black" stroke-width="5.30401" stroke-linejoin="round" />
        </svg>

    )
}